export const convertObjectToCss = (variables: Record<string, string>) => {
  return Object.entries(variables)
    .map(([k, v]) => `${k}: ${v};`)
    .join('\n')
}
